module.exports = __webpack_public_path__ + "img/图片7.26481431.png";